
// @ts-nocheck


export const localeCodes =  [
  "en-gb",
  "en-au",
  "de-at",
  "nl-be",
  "fr-be",
  "en-ca",
  "fr-ca",
  "da",
  "fr",
  "de",
  "en-ie",
  "it",
  "ja",
  "no",
  "pl",
  "pt",
  "es",
  "sv",
  "de-ch",
  "fr-ch",
  "it-ch",
  "nl",
  "en-nz",
  "en-us"
]

export const localeLoaders = {
  "en-gb": [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_en_45gb_46ts_4f558852",
      load: () => import("#nuxt-i18n/4f558852" /* webpackChunkName: "locale_en_45gb_46ts_4f558852" */),
      cache: true
    }
  ],
  "en-au": [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_en_45au_46ts_b5ca20ac",
      load: () => import("#nuxt-i18n/b5ca20ac" /* webpackChunkName: "locale_en_45au_46ts_b5ca20ac" */),
      cache: true
    }
  ],
  "de-at": [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_de_46ts_5609ce5d",
      load: () => import("#nuxt-i18n/5609ce5d" /* webpackChunkName: "locale_de_46ts_5609ce5d" */),
      cache: true
    },
    {
      key: "locale_de_45at_46ts_cd1baaa3",
      load: () => import("#nuxt-i18n/cd1baaa3" /* webpackChunkName: "locale_de_45at_46ts_cd1baaa3" */),
      cache: true
    }
  ],
  "nl-be": [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_nl_46ts_56244e9c",
      load: () => import("#nuxt-i18n/56244e9c" /* webpackChunkName: "locale_nl_46ts_56244e9c" */),
      cache: true
    },
    {
      key: "locale_nl_45be_46ts_d7bf1e03",
      load: () => import("#nuxt-i18n/d7bf1e03" /* webpackChunkName: "locale_nl_45be_46ts_d7bf1e03" */),
      cache: true
    }
  ],
  "fr-be": [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_fr_46ts_f2f52052",
      load: () => import("#nuxt-i18n/f2f52052" /* webpackChunkName: "locale_fr_46ts_f2f52052" */),
      cache: true
    },
    {
      key: "locale_fr_45be_46ts_6c8e7606",
      load: () => import("#nuxt-i18n/6c8e7606" /* webpackChunkName: "locale_fr_45be_46ts_6c8e7606" */),
      cache: true
    }
  ],
  "en-ca": [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_en_45ca_46ts_3dcb3d02",
      load: () => import("#nuxt-i18n/3dcb3d02" /* webpackChunkName: "locale_en_45ca_46ts_3dcb3d02" */),
      cache: true
    }
  ],
  "fr-ca": [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_fr_46ts_f2f52052",
      load: () => import("#nuxt-i18n/f2f52052" /* webpackChunkName: "locale_fr_46ts_f2f52052" */),
      cache: true
    },
    {
      key: "locale_fr_45ca_46ts_082f1b19",
      load: () => import("#nuxt-i18n/082f1b19" /* webpackChunkName: "locale_fr_45ca_46ts_082f1b19" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_da_46ts_6581a286",
      load: () => import("#nuxt-i18n/6581a286" /* webpackChunkName: "locale_da_46ts_6581a286" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_fr_46ts_f2f52052",
      load: () => import("#nuxt-i18n/f2f52052" /* webpackChunkName: "locale_fr_46ts_f2f52052" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_de_46ts_5609ce5d",
      load: () => import("#nuxt-i18n/5609ce5d" /* webpackChunkName: "locale_de_46ts_5609ce5d" */),
      cache: true
    }
  ],
  "en-ie": [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_en_45ie_46ts_e48c7f4d",
      load: () => import("#nuxt-i18n/e48c7f4d" /* webpackChunkName: "locale_en_45ie_46ts_e48c7f4d" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_it_46ts_94d5fc32",
      load: () => import("#nuxt-i18n/94d5fc32" /* webpackChunkName: "locale_it_46ts_94d5fc32" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_ja_46ts_32a9648c",
      load: () => import("#nuxt-i18n/32a9648c" /* webpackChunkName: "locale_ja_46ts_32a9648c" */),
      cache: true
    }
  ],
  no: [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_no_46ts_919605cb",
      load: () => import("#nuxt-i18n/919605cb" /* webpackChunkName: "locale_no_46ts_919605cb" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_pl_46ts_90ad19e3",
      load: () => import("#nuxt-i18n/90ad19e3" /* webpackChunkName: "locale_pl_46ts_90ad19e3" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_pt_46ts_8c3f1799",
      load: () => import("#nuxt-i18n/8c3f1799" /* webpackChunkName: "locale_pt_46ts_8c3f1799" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_es_46ts_819708ec",
      load: () => import("#nuxt-i18n/819708ec" /* webpackChunkName: "locale_es_46ts_819708ec" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_sv_46ts_0aaa5b2a",
      load: () => import("#nuxt-i18n/0aaa5b2a" /* webpackChunkName: "locale_sv_46ts_0aaa5b2a" */),
      cache: true
    }
  ],
  "de-ch": [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_de_46ts_5609ce5d",
      load: () => import("#nuxt-i18n/5609ce5d" /* webpackChunkName: "locale_de_46ts_5609ce5d" */),
      cache: true
    },
    {
      key: "locale_de_45ch_46ts_5c22dc05",
      load: () => import("#nuxt-i18n/5c22dc05" /* webpackChunkName: "locale_de_45ch_46ts_5c22dc05" */),
      cache: true
    }
  ],
  "fr-ch": [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_fr_46ts_f2f52052",
      load: () => import("#nuxt-i18n/f2f52052" /* webpackChunkName: "locale_fr_46ts_f2f52052" */),
      cache: true
    },
    {
      key: "locale_fr_45ch_46ts_097e997e",
      load: () => import("#nuxt-i18n/097e997e" /* webpackChunkName: "locale_fr_45ch_46ts_097e997e" */),
      cache: true
    }
  ],
  "it-ch": [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_it_46ts_94d5fc32",
      load: () => import("#nuxt-i18n/94d5fc32" /* webpackChunkName: "locale_it_46ts_94d5fc32" */),
      cache: true
    },
    {
      key: "locale_it_45ch_46ts_97d3699d",
      load: () => import("#nuxt-i18n/97d3699d" /* webpackChunkName: "locale_it_45ch_46ts_97d3699d" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_nl_46ts_56244e9c",
      load: () => import("#nuxt-i18n/56244e9c" /* webpackChunkName: "locale_nl_46ts_56244e9c" */),
      cache: true
    }
  ],
  "en-nz": [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_en_45nz_46ts_8fd58a18",
      load: () => import("#nuxt-i18n/8fd58a18" /* webpackChunkName: "locale_en_45nz_46ts_8fd58a18" */),
      cache: true
    }
  ],
  "en-us": [
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_en_46ts_a55d274a",
      load: () => import("#nuxt-i18n/a55d274a" /* webpackChunkName: "locale_en_46ts_a55d274a" */),
      cache: true
    },
    {
      key: "locale_en_45us_46ts_7ea469a8",
      load: () => import("#nuxt-i18n/7ea469a8" /* webpackChunkName: "locale_en_45us_46ts_7ea469a8" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/f996c921" /* webpackChunkName: "config_i18n_46config_46ts_f996c921" */)
]

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    jit: true,
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en-gb",
      iso: "en-gb",
      language: "en-gb",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/en-gb.ts"
      ]
    },
    {
      code: "en-au",
      iso: "en-au",
      language: "en-au",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/en-au.ts"
      ]
    },
    {
      code: "de-at",
      iso: "de-at",
      language: "de-at",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/de.ts",
        "/vercel/path0/layers/base/config/i18n/translations/de-at.ts"
      ]
    },
    {
      code: "nl-be",
      iso: "nl-be",
      language: "nl-be",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/nl.ts",
        "/vercel/path0/layers/base/config/i18n/translations/nl-be.ts"
      ]
    },
    {
      code: "fr-be",
      iso: "fr-be",
      language: "fr-be",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/fr.ts",
        "/vercel/path0/layers/base/config/i18n/translations/fr-be.ts"
      ]
    },
    {
      code: "en-ca",
      iso: "en-ca",
      language: "en-ca",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/en-ca.ts"
      ]
    },
    {
      code: "fr-ca",
      iso: "fr-ca",
      language: "fr-ca",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/fr.ts",
        "/vercel/path0/layers/base/config/i18n/translations/fr-ca.ts"
      ]
    },
    {
      code: "da",
      iso: "da",
      language: "da",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/da.ts"
      ]
    },
    {
      code: "fr",
      iso: "fr",
      language: "fr",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/fr.ts"
      ]
    },
    {
      code: "de",
      iso: "de",
      language: "de",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/de.ts"
      ]
    },
    {
      code: "en-ie",
      iso: "en-ie",
      language: "en-ie",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/en-ie.ts"
      ]
    },
    {
      code: "it",
      iso: "it",
      language: "it",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/it.ts"
      ]
    },
    {
      code: "ja",
      iso: "ja",
      language: "ja",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/ja.ts"
      ]
    },
    {
      code: "no",
      iso: "no",
      language: "no",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/no.ts"
      ]
    },
    {
      code: "pl",
      iso: "pl",
      language: "pl",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/pl.ts"
      ]
    },
    {
      code: "pt",
      iso: "pt",
      language: "pt",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/pt.ts"
      ]
    },
    {
      code: "es",
      iso: "es",
      language: "es",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/es.ts"
      ]
    },
    {
      code: "sv",
      iso: "sv",
      language: "sv",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/sv.ts"
      ]
    },
    {
      code: "de-ch",
      iso: "de-ch",
      language: "de-ch",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/de.ts",
        "/vercel/path0/layers/base/config/i18n/translations/de-ch.ts"
      ]
    },
    {
      code: "fr-ch",
      iso: "fr-ch",
      language: "fr-ch",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/fr.ts",
        "/vercel/path0/layers/base/config/i18n/translations/fr-ch.ts"
      ]
    },
    {
      code: "it-ch",
      iso: "it-ch",
      language: "it-ch",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/it.ts",
        "/vercel/path0/layers/base/config/i18n/translations/it-ch.ts"
      ]
    },
    {
      code: "nl",
      iso: "nl",
      language: "nl",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/nl.ts"
      ]
    },
    {
      code: "en-nz",
      iso: "en-nz",
      language: "en-nz",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/en-nz.ts"
      ]
    },
    {
      code: "en-us",
      iso: "en-us",
      language: "en-us",
      files: [
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        "/vercel/path0/layers/base/config/i18n/translations/en-us.ts"
      ]
    }
  ],
  defaultLocale: "en-gb",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "config/i18n/translations",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://business.toogoodtogo.com",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: [
    {
      langDir: "/vercel/path0/node_modules/.pnpm/nuxt-zod-i18n@1.12.1_magicast@0.5.3/node_modules/nuxt-zod-i18n/dist/runtime/i18n/locales",
      locales: []
    }
  ]
}

export const normalizedLocales = [
  {
    code: "en-gb",
    iso: "en-gb",
    language: "en-gb",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en-gb.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "en-au",
    iso: "en-au",
    language: "en-au",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en-au.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "de-at",
    iso: "de-at",
    language: "de-at",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/de.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/de-at.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "nl-be",
    iso: "nl-be",
    language: "nl-be",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/nl.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/nl-be.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "fr-be",
    iso: "fr-be",
    language: "fr-be",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/fr.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/fr-be.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "en-ca",
    iso: "en-ca",
    language: "en-ca",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en-ca.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "fr-ca",
    iso: "fr-ca",
    language: "fr-ca",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/fr.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/fr-ca.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "da",
    iso: "da",
    language: "da",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/da.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "fr",
    iso: "fr",
    language: "fr",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/fr.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "de",
    iso: "de",
    language: "de",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/de.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "en-ie",
    iso: "en-ie",
    language: "en-ie",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en-ie.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "it",
    iso: "it",
    language: "it",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/it.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "ja",
    iso: "ja",
    language: "ja",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/ja.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "no",
    iso: "no",
    language: "no",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/no.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "pl",
    iso: "pl",
    language: "pl",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/pl.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "pt",
    iso: "pt",
    language: "pt",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/pt.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "es",
    iso: "es",
    language: "es",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/es.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "sv",
    iso: "sv",
    language: "sv",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/sv.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "de-ch",
    iso: "de-ch",
    language: "de-ch",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/de.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/de-ch.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "fr-ch",
    iso: "fr-ch",
    language: "fr-ch",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/fr.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/fr-ch.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "it-ch",
    iso: "it-ch",
    language: "it-ch",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/it.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/it-ch.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "nl",
    iso: "nl",
    language: "nl",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/nl.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "en-nz",
    iso: "en-nz",
    language: "en-nz",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en-nz.ts",
        cache: undefined
      }
    ],
    file: undefined
  },
  {
    code: "en-us",
    iso: "en-us",
    language: "en-us",
    files: [
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en.ts",
        cache: undefined
      },
      {
        path: "/vercel/path0/layers/base/config/i18n/translations/en-us.ts",
        cache: undefined
      }
    ],
    file: undefined
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/